<script>
import ReviewFormHeader from '@/components/ReviewFormHeader'
import rubric from '@/assets/courseReview/rubric.json'
import ReviewSections from '@/components/ReviewSections'
import GNavBar from '@/components/GNavBar'
import TheReviewSubmitButton from '@/components/TheReviewSubmitButton'

export default {
  name: 'TheReviewForm',
  components: {
    ReviewFormHeader,
    ReviewSections,
    TheReviewSubmitButton,
    GNavBar
  },
  data() {
    return {
      rubric,
      formSubmitted: null,
      formSubmissionMessage:
        'Thank you for your submission. It has been successfully recorded, and the OFDIT lead has been notified.'
    }
  },
  computed: {
    reviewInfo() {
      return this.$store.getters.reviewInfo
    },
    comment() {
      return this.$store.state.courseReview.commentToEdit
    },
    dashboard() {
      if (
        this.reviewInfo.reviewer_role === 'OFDIT reviewer' ||
        this.reviewInfo.reviewer_role === 'Peer reviewer'
      ) {
        return false
      }
      return true
    },
    nextStage() {
      let result = null
      switch (this.reviewInfo.status) {
        case 'Reviews submitted':
          result = 'Released to AD & dev'
          break
        case 'Released to AD & dev':
          result = 'Developer response'
          break
        case 'Released to AD':
          result = 'Released to AD & dev'
          break
        case 'Developer response':
          result = 'Closed'
          break
      }
      return result
    }
  },
  methods: {
    async updateComment() {
      try {
        if (!this.comment.content) {
          throw new Error('You cannot create an empty comment.')
        }
        await this.$store.dispatch('cr_callAPI', {
          url: `/r/comments/${this.reviewInfo.id}/${this.comment.id}/edit`,
          method: 'put',
          data: { content: this.comment.content.trim() }
        })
        this.$bvModal.hide('edit-modal')
        this.$root.$bvToast.toast('Comment successfully edited.', {
          title: 'Success',
          autoHideDelay: 1000,
          toaster: 'b-toaster-top-center',
          variant: 'success'
        })
      } catch (err) {
        this.$root.$bvToast.toast(
          `${err.message} If the problem persists, please contact the OFDIT lead.`,
          {
            title: 'Error',
            toaster: 'b-toaster-top-center',
            variant: 'danger'
          }
        )
      } finally {
        const comments = await this.$store.dispatch('cr_callAPI', {
          url: `/r/reviews/${this.reviewInfo.id}/comments`
        })
        this.$store.commit('cr_updateComments', comments)
      }
    },
    onSubmit() {
      try {
        this.$store.dispatch('cr_callAPI', {
          url: `/r/reviews/${this.reviewInfo.id}/status`,
          method: 'put',
          data: {
            new_status: this.nextStage,
            project_id: this.reviewInfo.project_id
          }
        })
        this.formSubmitted = true
        this.$root.$bvToast.toast(
          `You have successfully updated the status for the review of ${this.reviewInfo.course}`,
          {
            title: 'Success',
            autoHideDelay: 1000,
            toaster: 'b-toaster-top-center',
            variant: 'success'
          }
        )
      } catch (err) {
        this.$root.$bvToast.toast(
          `Error updating the status of the review of ${this.reviewInfo.course}. If the problem persists, please contact the OFDIT lead\n${err.message}.
      ${err.message}`,
          {
            title: 'Error',
            toaster: 'b-toaster-top-center',
            variant: 'danger'
          }
        )
      }
    },
    async submitRatings() {
      try {
        await this.$store.dispatch('cr_callAPI', {
          url: `/r/reviews/${this.reviewInfo.id}/rating`,
          method: 'put'
        })
        this.formSubmitted = true
        this.$root.$bvToast.toast(
          `You have successfully submitted your review of ${this.reviewInfo.course}`,
          {
            title: 'Success',
            autoHideDelay: 1000,
            toaster: 'b-toaster-top-center',
            variant: 'success'
          }
        )
      } catch (err) {
        this.$root.$bvToast.toast(
          `Error submitting your review of ${this.reviewInfo.course}. If the problem persists, please contact the OFDIT lead.
      ${err.message}`,
          {
            title: 'Error',
            toaster: 'b-toaster-top-center',
            variant: 'danger'
          }
        )
      }
    }
  }
}
</script>

<template>
  <div>
    <div v-if="!formSubmitted">
      <div v-if="!dashboard">
        <h1 class="pt-5">Course review form</h1>
      </div>
      <div v-else>
        <GNavBar v-if="reviewInfo.reviewer_role !== 'Developer'" />
        <h1 class="mt-5 pt-5">Course review dashboard</h1>
      </div>
      <hr />
      <b-row align-h="center">
        <b-col>
          <h3 class="mb-n1">
            {{ reviewInfo.course }}
          </h3>
          <h5 class="text-muted">
            <span class="text-muted">{{ reviewInfo.project_id }}: {{ reviewInfo.dev_full_name }}</span>
          </h5>
          <b-card>
            <ReviewFormHeader />
            <b-form @submit.prevent="onSubmit">
              <ReviewSections v-for="category in rubric" :key="category.id" :categoryObject="category" />
              <TheReviewSubmitButton v-if="dashboard" />
              <div v-else>
                <b-button @click="submitRatings" class="float-right" size="lg" variant="primary">Submit ratings (I'm
                  done)</b-button>
              </div>
            </b-form>
          </b-card>
        </b-col>
      </b-row>
    </div>
    <div v-else>
      <h1 class="pt-5">Thank you for your submission</h1>
      <hr />
      <b-alert :show="formSubmitted">{{ formSubmissionMessage }}</b-alert>
    </div>
    <b-modal id="edit-modal">
      <b-row class="mx-auto p-3">
        <textarea v-model="comment.content" cols="60" rows="10"></textarea>
      </b-row>
      <template #modal-footer>
        <b-row class="p-3 justify-content-end">
          <b-button @click="updateComment" variant="success">Update comment</b-button>
        </b-row>
      </template>
    </b-modal>
  </div>
</template>
<style scoped></style>
